/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Placeholder_EmailInputs */

const et_contact_placeholder_email = /** @type {(inputs: Contact_Placeholder_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nimi@ettevote.ee`)
};

const en_contact_placeholder_email = /** @type {(inputs: Contact_Placeholder_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`name@company.com`)
};

/**
* | output |
* | --- |
* | "name@company.com" |
*
* @param {Contact_Placeholder_EmailInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_placeholder_email = /** @type {((inputs?: Contact_Placeholder_EmailInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Placeholder_EmailInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_contact_placeholder_email(inputs)
	return en_contact_placeholder_email(inputs)
});